import React from 'react'
import {
    Container,
    createStyles,
    makeStyles,
    Theme, Typography,
} from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            paddingTop: 50,
        },
    }),
);

export default function DraftContractCreatedPage() {
    const classes = useStyles();
    
    return (
        <Container maxWidth="lg" className={classes.container}>
            <h2>Draft Contract Created</h2>
            <Typography variant="body1">
                Draft Contract created successfully. Please wait for the administrator to review the contract. You will receive an email when the contract is reviewed
            </Typography>
        </Container>
    )
}
